const redirectUri = process.env.REACT_APP_REDIRECTURI;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    // Keep auth state in localStorage only so clearing site storage actually ends the app session.
    storeAuthStateInCookie: false,
  },
};

// Microsoft 365 / Graph scopes used for sign-in.
// Backend API calls reuse the ID token from this session (see authApi.js).
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "User.Read",
    "Calendars.Read",
    "Chat.Create",
    "Chat.ReadWrite",
    "Chat.ReadWrite.All",
    "Sites.Read.All",
    "Files.ReadWrite.All",
  ],
};

export const logoutRequest = {
  postLogoutRedirectUri: redirectUri,
};
